import React from "react"
import { Link } from "react-router-dom"
import { useWaitingListPreview, waitingEntryName, waitingEntriesPath } from "./waitingListPreview"

export default function WaitingListStatus({ eventId, competitionId, version, pointsSaved, processing }) {
  const request = useWaitingListPreview(eventId, competitionId, version, pointsSaved)
  if (!pointsSaved) return null
  if (request.loading) return <p role="status">Checking the remaining Waiting List entries…</p>
  if (request.error) return <div className="alert alert-warning" role="status">Points are saved, but the remaining Waiting List entries could not be checked. <button className="btn btn-light btn-sm" onClick={request.retry}>Check Waiting List</button></div>
  const entries = [...request.data.eligible, ...request.data.review]
  if (!entries.length) return null
  const pending = processing || entries.some(entry => entry.reason === "ENTRY_OPERATION_IN_PROGRESS")
  return <section className="alert alert-warning" aria-label="Remaining Waiting List entries">
    <p role="status" className="mb-1"><strong>Points saved. {entries.length} {entries.length === 1 ? "entry remains" : "entries remain"} on the Waiting List{pending ? ". Withdrawal processing is still pending." : entries.length === 1 ? " and requires review." : " and require review."}</strong></p>
    <p className="mb-2">{entries.map(waitingEntryName).join("; ")}</p>
    <Link className="btn btn-outline-primary btn-sm mr-2" to={waitingEntriesPath(eventId, competitionId)}>Review waiting entries</Link>
    <button className="btn btn-light btn-sm" onClick={request.retry}>Check Waiting List</button>
  </section>
}
